export default class AppTable {
    constructor () {
        let self = this;
        $('[data-toggle=table]').each(function () {
            self.init($(this));
        });
    }

    init ($list) {
        let $table = $list.find('table');

        let $wrapper = $table.parent();
        $wrapper.addClass('table-responsive m-0');
        let $tHead = $table.find('thead');
        let $tBody = $table.find('tbody');
        $table.addClass('table table-hover m-0');
        $tBody.addClass('d-none');
        let $progress = $('<div class="progress mb-2 rounded-0"><div class="progress-bar progress-bar-warning progress-bar-striped progress-bar-animated w-100"></div></div>').insertBefore($table);
        let dataUrl = $table.attr('data-url');
        let template = Handlebars.templates[$table.attr('data-row-template')];
        let additionalData = $table.data('additional-data');

        $.getJSON(dataUrl, function (rows) {
            $.each(rows, function (i) {
                let row = this;
                $.each(additionalData, function (j) {
                    row[j] = this.replace('row_id', row.id);
                });
                $tBody.append(template(row));
            });
            $progress.remove();
            $tBody.removeClass('d-none');
            $tBody.addClass('list');
            $list.find('input[type=search]').addClass('search');

            $tHead.find('th[data-sort]').each(function () {
                let $th = $(this);
                $th.css('cursor', 'pointer');
                $th.addClass('sort');
                $th.append('<i class="fal fa-sort float-right"></i>');
            });

            let list = new List($list.attr('id'), {
                valueNames: $list.data('columns'),
            });

            let sortColumn = $list.attr('data-sort-column');
            if (sortColumn) {
                let sortDir = $list.attr('data-sort-dir') || 'asc';
                list.sort(sortColumn, {
                    order: sortDir,
                });
            }

            let filters = {};

            $list.on('table.list.filter', function () {
                if (Object.keys(filters).length === 0) {
                    list.filter();
                } else {
                    list.filter(function (item) {
                        for (let i = 0; i < Object.keys(filters).length; i++) {
                            let filterColumn = Object.keys(filters)[i];
                            let filter = filters[filterColumn];

                            if (
                                filter.cmp === 'EQUAL' &&
                                item.values()[filterColumn] !== filter.value
                            ) {
                                return false;
                            } else if (
                                filter.cmp === 'LIKE' &&
                                !item.values()[filterColumn].toLowerCase().includes(filter.value.toLowerCase())
                            ) {
                                return false;
                            }
                        }

                        return true;
                    });
                }
            });

            $list.find('[data-filter]').each(function () {
                let $filter = $(this);
                let filterColumn = $filter.attr('data-filter');

                if ($filter.is('select')) {
                    let options = {};
                    list.items.forEach(function (item) {
                        options[item.values()[filterColumn]] = $(item.elm).find('.' + filterColumn).text().trim();
                    });
                    Object.keys(options).forEach(function (key) {
                        $filter.append($('<option/>')
                            .val(key)
                            .text(options[key]));
                    });

                    $filter.on('change', function () {
                        let filterValue = $filter.val();

                        if (filterValue === '') {
                            delete filters[filterColumn];
                        } else {
                            filters[filterColumn] = {
                                value: filterValue,
                                cmp: 'EQUAL',
                            };
                        }
                        $list.trigger('table.list.filter');
                    });
                } else if ($filter.is('input[type=text]')) {
                    $filter.on('keyup', function () {
                        let filterValue = $filter.val();

                        if (filterValue === '') {
                            delete filters[filterColumn];
                        } else {
                            filters[filterColumn] = {
                                value: filterValue,
                                cmp: 'LIKE',
                            };
                        }
                        $list.trigger('table.list.filter');
                    });
                }
            });

            window.app.tooltip.init();
        });
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/table.js